import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import s from './style.module.scss';

const Laura = ({ setOnRendered }) => {
  const { currentCover } = useSelector((state) => state.templatesReducer);

  useEffect(() => {
    setOnRendered(true);
  });
  return (
    <>
      {currentCover && (
        <div className={s.c}>
          <div className="section-col">
            <div className="section">
              <div className="sub-section">
                <div className={s.laura__name}>
                  <div className={s.laura__wrap}>
                    {currentCover.firstName} {currentCover.lastName}
                  </div>
                </div>
              </div>
            </div>
            <div className="section">
              <div className={s.main}>
                <div className={`${s.main__row} sub-section`}>
                  <div className={s.main__title}>
                    {currentCover.jobTitle} <span>{currentCover.date}</span>
                  </div>
                </div>

                {currentCover.greeting && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.greeting}</div>
                  </div>
                )}

                {currentCover.openingParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.openingParagraph}</div>
                  </div>
                )}

                {currentCover.secondParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.secondParagraph}</div>
                  </div>
                )}

                {currentCover.thirdParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.thirdParagraph}</div>
                  </div>
                )}

                {currentCover.signature && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.signature}</div>
                  </div>
                )}
              </div>
            </div>
            <div className={s.contacts}>
              <div className={`${s.contacts__item} ${s.contacts__text__state}`}>
                <div className={s.contacts__text}>
                  {currentCover.country.name}, {currentCover.city.name}
                  {currentCover.state && `, ${currentCover.state}`}
                  {currentCover.zip && `, ${currentCover.zip}`}
                </div>
              </div>
              {currentCover.phone && (
                <div className={`${s.contacts__item} ${s.contacts__text__phone}`}>
                  <div className={s.contacts__text}>{currentCover.phone}</div>
                </div>
              )}
              {currentCover.email && (
                <div className={`${s.contacts__item} ${s.contacts__text__mail}`}>
                  <div className={s.contacts__text}>{currentCover.email}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Laura.propTypes = {
  setOnRendered: PropTypes.func.isRequired,
};
export default Laura;
